// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"1718d332","369":"1718d332"}[chunkId] + ".chunk.css";
};